import { render, staticRenderFns } from "./SystemTile.vue?vue&type=template&id=36009778&scoped=true&"
import script from "./SystemTile.vue?vue&type=script&lang=js&"
export * from "./SystemTile.vue?vue&type=script&lang=js&"
import style0 from "./SystemTile.vue?vue&type=style&index=0&id=36009778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36009778",
  null
  
)

export default component.exports